import {Component, Injector, OnInit} from '@angular/core';
import {CreatePageDialogComponent} from '../../dialog/create-page-dialog/create-page-dialog.component';
import {BasePageComponent} from '../../../shared/components/base-page.component';
import {AuthService} from '../../../core/services/auth/auth.service';

/**
 * The default template for pages module. It is used when the active user has no page.
 * */
@Component({
  selector: 'no-page',
  templateUrl: './no-page.component.html',
  styleUrls: ['./no-page.component.scss'],
  host: {
    class: 'w-100 h-100'
  }
})
export class NoPageComponent extends BasePageComponent implements OnInit {

  private keycloakRealmId: string | null = null; // realm id
  authService: AuthService;

  constructor(protected injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.keycloakRealmId = this.authService.getRealmId(true);
    this.menuService.setMenuVisibility(true);
  }

  /**
   * Getter to determine if the current realm is not 'devicemanagement'
   */
  get canCreatePage(): boolean {
    return this.keycloakRealmId !== 'devicemanagement';
  }

  /**
   * Opens {@link CreatePageDialogComponent} to allow users to create new pages
   * */
  openCreatePageDialog() {
    this.dialogService.open(CreatePageDialogComponent);
  }
}
